<ng-container *ngIf="!isLoading;  ">
    <div class="card padding15 text-justify" id="print-section">
        <div class="card-body">
            <form [formGroup]="monkeypoxAgreeFrm">
                 <div class="p-2 mb-2 card-title  text-white  ng-star-inserted" style="background-color:#337AB7">
                        <span class="text-justify">
                            &nbsp; Monkeypox Provider Agreement</span>
                    </div>
                    <div class="paddingTop10"></div>

                <div class="p-2 mb-2 card-title ng-star-inserted" style="background-color:#DFF0D8">
                    <span>
                        Please review the requirements in the HHS Monkeypox Vaccination Provider Agreement
                        by selecting the "Click Here" link below.</span>
                </div>
                <div class="col-xs-14 paddingTop10 hiddenPrint mb-2">
                    <span class="text-justify"> &nbsp;&nbsp;Download HHS Monkeypox Vaccination Program Provider Agreement.
                        <a href="../../docs/monkeypox/HHS_Monkeypox_Vaccination_Program_Provider_Agreement.pdf"
                            download>Click Here</a>
                    </span>
                </div>
                <div class="col-xs-12 paddingTop10">
                    <div class="p-2 mb-2 card-title  text-white  ng-star-inserted" style="background-color:#337AB7">
                        <span class="text-justify">
                            &nbsp; Primary and Backup Vaccine Coordinators</span>
                    </div>
                    <div class="paddingTop10"></div>

                    <div class="p-2 mb-2 card-title  ng-star-inserted" style="background-color:#DFF0D8">
                        Please select the name of the individuals who will be responsible for monitoring the
                        Monkeypox vaccination campaign and implementation of the requirements within the provider
                        agreement.</div>

                    <div class="col-xs-14 paddingTop10"></div>

                    <div class="p-2 mb-2 card-title ng-star-inserted" style="background-color:#F2DEDE">
                        <span class="text-justify">&nbsp;*Vaccine Coordinators must be NJIIS users associated with your facility to be selected
                            below. If you have questions please submit a Help Desk <a href="javascript:void(0)"
                                (click)="navigateToHippocrates()">ticket</a> for assistance.</span>

                    </div>

                    <div class="d-flex flex-wrap justify-content-start row">
                        <div class="d-flex flex-column col-md-6 col-sm-12">
                            <label for="Primary Monkeypox Coordinator" class="col-form-label">Primary Monkeypox
                                Coordinator<app-required-label>
                                </app-required-label></label>
                            <app-select [options]="primaryUsersList" [optionValue]="'idSeq'" [label]="'fullName'"
                                formControlName="primaryMonkeypoxCoordinator" [ngClass]="{'is-invalid':
              isControlInvalid(f.primaryMonkeypoxCoordinator)}" [disabled]="disableForm"
                                [isInvalid]="isControlInvalid(f.primaryMonkeypoxCoordinator)"
                                (changeEvent)="primaryMonkeypoxCoordinatorChange()">
                            </app-select>
                            <app-error [caption]="'Primary Monkeypox Coordinator'"
                                [control]="f.primaryMonkeypoxCoordinator" [isSubmit]=this.isSubmit
                                class="invalid-feedback">
                            </app-error>
                        </div>
                        <div class="d-flex flex-column col-md-6 col-sm-12">
                            <label for="Backup Monkeypox Coordinator" class="col-form-label">Backup Monkeypox
                                Coordinator<app-required-label>
                                </app-required-label></label>
                            <app-select [options]="backupUsersList" [optionValue]="'idSeq'" [label]="'fullName'"
                                formControlName="backupMonkeypoxCoordinator" [ngClass]="{'is-invalid':
              isControlInvalid(f.backupMonkeypoxCoordinator)}" [disabled]="disableForm"
                                [isInvalid]="isControlInvalid(f.backupMonkeypoxCoordinator)"
                                (changeEvent)="backupMonkeypoxCoordinatorChange()">
                            </app-select>
                            <app-error [caption]="'Backup Monkeypox Coordinator'"
                                [control]="f.backupMonkeypoxCoordinator" [isSubmit]=this.isSubmit
                                class="invalid-feedback">
                            </app-error>
                        </div>
                    </div>
                </div>
                <br>
                <div class="p-2 mb-2 card-title  ng-star-inserted" style="background-color:#DFF0D8">
                    <span>
                        Once this information has been reviewed, please select the check box next to the statement below.
                        It is the responsibility of your organization to remain up to date with updates for the provider
                        agreement.
                        Up to date information can be found at the following website: <a
                            href="https://www.cdc.gov/poxvirus/monkeypox/clinicians/provider-agreement.html"
                            target="_blank"><strong>https://www.cdc.gov/poxvirus/monkeypox/clinicians/provider-agreement.html</strong>
                        </a> </span>
                </div>


                <div class="form-group form-check">
                    <input type="checkbox" name="agreement_flag" id="agreement_flag"
                        [attr.disabled]="disableForm ? true : null" formControlName="agreement_flag"
                        class="form-check-input"
                        [ngClass]="{ 'is-invalid': this.isSubmit && f['agreement_flag'].errors }" />
                        <label for="agreement_flag" class="form-check-label">By checking this box you are noting that you have reviewed the
                    Provider Agreement for the HHS Monkeypox Vaccination Program.  Your organization is expected to
                    comply with all of its requirements. Upon any use of the Jynneos or ACAM2000 vaccine provided at no
                    cost by the US government, the provider and providers organization (Organization) will be deemed to
                    have agreed to comply with the requirements of the Provider Agreement, including any updates.</label>


                    <div *ngIf="isSubmit && f['agreement_flag'].errors" class="invalid-feedback">
                        Please select Agreement checkbox
                      </div>

                    <!-- <app-error [caption]="'Monkeypox Agreement Flag'"
                    [control]="f.agreement_flag" [isSubmit]=this.isSubmit
                    class="invalid-feedback">
                </app-error>  -->
                </div>

                <div class="d-flex flex-wrap justify-content-start row">
                    <div class="d-flex flex-column col-md-6 col-sm-12">
                        <label for="Full Name" class="col-form-label">Full Name<app-required-label>
                            </app-required-label></label>
                        <div>{{this.monkeypoxAgreeFrm.controls['agreeInit'].value}}</div>
                        <!-- <input type="text" formControlName="agreeInit"/> -->
                    </div>
                    <div class="d-flex flex-column col-md-6 col-sm-12">
                        <label for="Date of Acknowledgement" class="col-form-label">Date of Acknowledgement
                            <app-required-label>
                            </app-required-label></label>
                        <div>{{this.monkeypoxAgreeFrm.controls['agreement_date'].value}}</div>
                        <!-- <input type="text" formControlName="agreement_date"/> -->
                    </div>
                </div>
                <div class="paddingTop10"></div>
                <br>

               <div class="card-footer d-flex justify-content-end">


                    <button pRipple type="button" class="btn btn-sm btn-default" *ngIf="!disableForm || action === 'UPDATE'"
                        (click)="resetMonkeypoxAgreement()">Reset</button>
                    <button  pRipple type="button" class="btn btn-sm btn-default"
                            (click)="printForm('print-section')">Print</button>
                    <button pRipple type="submit" class="btn btn-sm btn-primary"   *ngIf="!disableForm || action === 'UPDATE'"
                            (click)="submitMonkeypoxAgreement()">Submit</button>

                </div>

            </form>
        </div>
    </div>
</ng-container>
